const o = ["playground", "violence"];
export {
  o as iconNames
};
//# sourceMappingURL=index.es12.js.map
